import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard, DeactivateGuard, ReversalAuthGuard} from 'app/services';
import {MainComponent} from 'app/layouts/main/main.component';
import {LoginComponent} from 'app/containers/start/login/login.component';
import {NotFoundComponent} from 'app/containers/not-found/not-found.component';
import {OverviewComponent} from 'app/containers/overview/overview/overview.component';
import {StartedDownloadsComponent} from "./containers/get-started/started-downloads/started-downloads.component";
import {HelpComponent} from "./containers/help/help.component";
import StationLoaderComponent from "./containers/stations/station-loader/station-loader.component";
import {UserSettingsComponent} from "./containers/user/user-settings/user-settings.component";
import {AccountDetailsComponent} from "./containers/account/account-details/account-details.component";
import { HomeComponent } from './containers/home/home.component';
import { RagComponent } from './containers/rag/rag.component';
import {WizardUpgradeComponent} from "./containers/user/wizard-upgarde/wizard-upgrade.component";

const routes: Routes = [
    {path: 'login', canActivate: [ReversalAuthGuard], component: LoginComponent, data: {title: 'Login'}},
    {path: 'login/features', canActivate: [ReversalAuthGuard], component: LoginComponent, data: {title: 'Login'}},
    {path: 'shopping-cart', children: [{path: '', loadChildren: () => import('./containers/cart/shopping.module').then(m => m.ShoppingModule)}], data: {title: 'Shopping cart'}},
    {path: 'monitor', children: [{path: '', loadChildren: () => import('./containers/monitor/monitor-module').then(m => m.MonitorModule)}], data: {title: 'Monitor'}},
    {path: 'login/:id', canActivate: [ReversalAuthGuard], component: LoginComponent, data: {title: 'Login'}},
    {path: 'login/amazonverified/:mode/:id', canActivate: [ReversalAuthGuard], component: LoginComponent, data: {title: 'Login'}},
    {path: 'getstarted', children: [{path: '', loadChildren: () => import('./containers/get-started/started.module').then(m => m.StartedModule)}], data: {title: 'Get started'}},
    {path: '', redirectTo: '/home', pathMatch: 'full'},
    {
        path: '', component: MainComponent,
        canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        children: [
            {
                path: 'editor',
                loadChildren: () => import('./containers/editor/editor.module').then(m => m.EditorModule)
            },
            {
                path: 'resources',
                loadChildren: () => import('./containers/resources/resources.module').then(m => m.ResourcesModule)
            },
            {
                path: 'shopping',
                loadChildren: () => import('./containers/cart/shopping.module').then(m => m.ShoppingModule)
            },
            {
                path: 'fasterq',
                loadChildren: () => import('./containers/fasterq/fasterq.module').then(m => m.FasterqModule)
            },
            {
                path: 'transitions',
                loadChildren: () => import('./containers/transitions/transitions.module').then(m => m.TransitionsModule)
            },
            {
                path: 'paint',
                loadChildren: () => import('./containers/paint/paint.module').then(m => m.PaintModule)
            },
            {
                path: 'music',
                loadChildren: () => import('./containers/music/music.module').then(m => m.MusicModule)
            },
            {
                path: 'catalog',
                loadChildren: () => import('./containers/catalog/catalog.module').then(m => m.CatalogModule)
            },
            {
                path: 'dynawebs',
                loadChildren: () => import('./containers/dynabwebs/dynawebs.module').then(m => m.DynawebsModule)
            },
            {
                path: 'events',
                loadChildren: () => import('./containers/events/events.module').then(m => m.EventsModule)
            },
            {
                path: 'enterprise',
                loadChildren: () => import('./containers/enterprise/enterprise.module').then(m => m.EnterpriseModule)
            },
            {
                path: 'adnet',
                loadChildren: () => import('./containers/adnet/adnet.module').then(m => m.AdnetModule)
            },
            {
                path: 'scheduler',
                loadChildren: () => import('./containers/scheduler/scheduler.module').then(m => m.SchedulerModule)
            },
            {path: 'home', component: HomeComponent, data: {title: 'Home'}},
            {path: 'rag', component: RagComponent, data: {title: 'RAG'}},
            {path: 'statistics', component: OverviewComponent, data: {title: 'Statistics'}},
            {path: 'stations', component: StationLoaderComponent, data: {title: 'Players'}},
            {path: 'stations/writing', component: NotFoundComponent, canDeactivate: [DeactivateGuard], data: {title: 'Create Post'}},
            {path: 'stations/writing/:id', component: NotFoundComponent, canDeactivate: [DeactivateGuard], data: {title: 'Update Post'}},
            {path: 'orders', component: AccountDetailsComponent, data: {title: 'orders'}},
            {path: 'orders/:order_id', component: AccountDetailsComponent, data: {title: 'orders'}},
            {path: 'download', component: StartedDownloadsComponent, data: {showHeader: false, showBack: false, title: 'Download'}},
            {path: 'prices', component: WizardUpgradeComponent, data: {state: 'showCloseButton:false'}},
            {path: 'help', component: HelpComponent, data: {showHeader: false, title: 'Help'}},
            {path: 'help/:video_id', component: HelpComponent, data: {showHeader: false, title: 'Help'}},
            {path: 'user', component: UserSettingsComponent, data: {title: 'Profile'}},
            {path: 'user/:id', component: UserSettingsComponent, data: {title: 'Profile'}}
        ]
    },
    {path: 'not-found', component: NotFoundComponent, data: {title: 'Page not found (404)'}},
    {path: '**', component: NotFoundComponent, data: {title: 'Page not found (404)'}}
];

@NgModule({
    imports: [
        // RouterModule.forRoot(routes, { enableTracing: !environment.production })
        RouterModule.forRoot(routes, {enableTracing: false})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
